import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, Check } from 'lucide-react';
import { useLanguage } from '../../context/LanguageContext';
import assetUrl from '../../assetUrl';
import './Hero.css';

function renderTitleLine(text) {
  if (!text) return null;
  const parts = text.split(/\[|\]/);
  return parts.map((part, i) =>
    i % 2 === 1 ? (
      <span className="hero-title-accent" key={i}>{part}</span>
    ) : (
      <span key={i}>{part}</span>
    )
  );
}

export default function Hero() {
  const { t, isRTL } = useLanguage();
  const [line1, line2] = (t.hero.title || '').split('//');

  return (
    <section className={`hero ${isRTL ? 'rtl' : ''}`}>
      <div
        className="hero-photo"
        style={{ backgroundImage: `url(${assetUrl('/images/hero-sworn-translation.png')}?v=4)` }}
        aria-hidden="true"
      />
      <div className="hero-shade" aria-hidden="true" />

      <div className="container hero-inner">
        <div className="hero-content">
          <h1 className="hero-title">
            <span className="hero-title-line">{renderTitleLine(line1)}</span>
            {line2 && <span className="hero-title-line">{renderTitleLine(line2)}</span>}
          </h1>

          <p className="hero-subtitle">{t.hero.subtitle}</p>

          <div className="hero-actions">
            <Link to="/order" className="hero-cta">
              {t.hero.cta}
            </Link>
            <Link to="/services" className="hero-cta hero-cta--ghost">
              {t.hero.ctaSecondary}
            </Link>
          </div>

          <div className="hero-trust">
            <span className="hero-trust-icon" aria-hidden="true">
              <Clock size={26} />
              <Check size={14} className="hero-trust-check" />
            </span>
            <p>{t.hero.trust}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
